import { axios } from "..";
import { AuditLog } from "../interfaces/models/IAudityLogs";

/** Multi-month audit timeline for one entity (defaults to Registration). */
export const getAuditLogsByEntity = async (params: {
  entityId: string;
  entity?: string;
  /** How many months back to include (1–36). Default handled by API as 6. */
  monthsBack?: number;
  fromEpochSec?: number;
  fromMonth?: string;
  toMonth?: string;
}): Promise<AuditLog[]> => {
  const search = new URLSearchParams();
  search.set("entityId", params.entityId);
  search.set("entity", params.entity ?? "Registration");
  if (params.monthsBack != null) {
    search.set("monthsBack", String(params.monthsBack));
  }
  if (params.fromEpochSec != null) {
    search.set("fromEpochSec", String(params.fromEpochSec));
  }
  if (params.fromMonth) {
    search.set("fromMonth", params.fromMonth);
  }
  if (params.toMonth) {
    search.set("toMonth", params.toMonth);
  }
  const response = await axios.Get(`./auditLog?${search.toString()}`);
  return Array.isArray(response.data) ? (response.data as AuditLog[]) : [];
};
